import { Box, Divider, Grid, Tab, Tabs } from "@mui/material";
import { useSelector } from "react-redux";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectEditDisabled, selectSelectedBuilderTab } from "../../../../store/selectors/uiSettingsSelectors";
import type { BuilderTab } from "../../../../store/types/uiSettingsState.types";
import { createUiSettingsAction } from "../../../../store/utils/storeUtils";
import type { TableComponentProps } from "../../../viewer/common/Types.ts";
import TableDragLayer from "../../common/table/TableDragLayer";
import ConditionsDropFieldsContainer from "../../pivot/table/conditions/ConditionsDropFieldsContainer";
import FormatContainer from "../settings/FormatContainer";
import SettingsContainer from "../settings/SettingsContainer";
import TileFieldsDropContainer from "./TileFieldsDropContainer";

const TableComponent = ({ ReportTypeSelector }: TableComponentProps) => {
  const dispatch = useAppDispatch();
  const selectedTab = useSelector(selectSelectedBuilderTab);
  const editDisabled = useSelector(selectEditDisabled);

  return (
    <Box sx={{ display: "flex", flex: 1, flexDirection: "column", gap: "1rem", mt: "1rem" }}>
      <Grid sx={{ px: "1.3rem" }}>
        {ReportTypeSelector}
        <Tabs
          value={selectedTab}
          sx={{ borderBottom: "none" }}
          onChange={(_, value: BuilderTab) => dispatch(createUiSettingsAction("setTab", value))}
        >
          <Tab value="Fields" label="Fields" />
          <Tab value="Settings" label="Settings" />
          <Tab value="Format" label="Format" />
        </Tabs>
      </Grid>
      <Divider sx={{ mt: -2 }} />
      {selectedTab === "Fields" && (
        <ScrollableFlexContainer
          scrollContainerSx={{ display: "flex", flexDirection: "column", gap: "1.5rem", px: "1.3rem" }}
        >
          <ConditionsDropFieldsContainer disableEqualitySelection={true} readonlyMode={editDisabled} />
          <TileFieldsDropContainer readonlyMode={editDisabled} />
          <TableDragLayer />
        </ScrollableFlexContainer>
      )}
      {selectedTab === "Settings" && <SettingsContainer />}
      {selectedTab === "Format" && <FormatContainer readonlyMode={editDisabled} />}
    </Box>
  );
};

export default TableComponent;
